import * as angular from 'angular';

"use strict";
angular.module('DragDropModule', []);

export default 'DragDropModule';
